import { Outlet } from "react-router-dom";

function Municipality() {
  return <Outlet />;
}

export default Municipality;
